/* jshint esversion: 6 */
import React from 'react';

class SubscriptionFeatureBlock extends React.Component {
    render() {
        //<li><div className="dlvr-icon-container"><i className="fa fa-rss"></i></div>Auto-sharing via RSS Feeds</li>
        //<li><div className="dlvr-icon-container"><i className="fa fa-pencil-square-o"></i></div>Automated Text Editing</li>
        return (
            <div className="feature-blocks">
                <h3>All dlvr.it paid plans include every one of these features</h3>
                <div className="feature-blocks-flex-wrapper">
                    <div className="feature-block first">
                        <ul className="feature-list">
                            <li><div className="dlvr-icon-container"><i className="ds-icon icon-gmb"></i></div>Google Business Profile</li>
                            <li><div className="dlvr-icon-container"><i className="fa fa-picture-o"></i></div>Stunning Photo Posts</li>
                            <li><div className="dlvr-icon-container"><i className="fa fa-rss"></i></div>Custom RSS Outputs</li>
                            <li><div className="dlvr-icon-container"><i className="fa fa-link"></i></div>Custom Short Links</li>
                            <li><div className="dlvr-icon-container"><i className="fa fa-heart"></i></div>Attentive Support</li>
                        </ul>
                    </div>
                    <div className="feature-block">
                        <ul className="feature-list">
                            <li><div className="dlvr-icon-container"><i className="ds-icon icon-x"></i></div>Connect X (Twitter)</li>
                            <li><div className="dlvr-icon-container"><i className="fa fa-pinterest"></i></div>Post Pinterest Photos</li>
                            <li><div className="dlvr-icon-container"><i className="fa fa-trophy"></i></div>Post to 18+ Social Networks</li>
                            <li><div className="dlvr-icon-container"><i className="ds-icon icon-ai"></i></div>AI post generator</li>
                            <li><div className="dlvr-icon-container"><i className="fa fa-clock-o"></i></div>Optimized Schedules</li>
                        </ul>
                    </div>
                    <div className="feature-block last">
                        <ul className="feature-list">
                            <li><div className="dlvr-icon-container"><i className="fa fa-instagram"></i></div>Connect Instagram</li>
                            <li><div className="dlvr-icon-container"><i className="fa fa-bars"></i></div>Easily Queue Posts</li>
                            <li><div className="dlvr-icon-container"><i className="fa fa-line-chart"></i></div>Engagement Stats</li>
                            <li><div className="dlvr-icon-container"><i className="fa fa-retweet"></i></div>Recycle Content</li>
                            <li><div className="dlvr-icon-container"><i className="fa fa-rocket"></i></div>Speedy Feed Updates</li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
};

export default SubscriptionFeatureBlock;
